import { Breadcrumb, Select, Input, Timeline } from "antd";
import { t } from "i18next";
import { ActiveDotIcon, InactiveDotIcon, BackIcon } from '../../../../asset';
import { CloseIcon } from '../../../../asset';
import React, { useEffect, useState } from 'react';
import style from './skillSetPage.module.css';
import ConfirmationModal from "../../../../component/modal/ConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import { useLocation, useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import TextArea from "antd/es/input/TextArea";
import { useSkillset } from "./SkillsetPage.hooks";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import DeleteConfirmationModal from "../../../../component/modal/DeleteConfirmationModal";

export default function SkillSetDetail() {
    const [userManagementOpen, setUserManagementOpen] = useState(false);

    const { state } = useLocation();
    const {
        doGetDetailSkillset,
        detailSkillset,
        convertTimestamp,
        convertToTime,
        toEditSkillSet,
        deleteConfirmation,
        deleteConfirmationModalOpen,
        setDeleteConfirmationModalOpen,
        successModalOpen,
        selectedId,
        doDeleteSkillset,
        doGetManagementHistoryList,
        managementHistoryList
    } = useSkillset();

    const navigate = useNavigate();
    const backToSkillsetList = () => {
        navigate(ROUTES.SKILLSET.LIST)
    }

    useEffect(() => {
        doGetDetailSkillset(state.id)
        doGetManagementHistoryList(state.id)
    }, [])

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <DeleteConfirmationModal
                isOpen={deleteConfirmationModalOpen}
                onOk={() => setDeleteConfirmationModalOpen(false)}
                onCancel={() => doDeleteSkillset()}
                closable={false}
                width={440}
                className={style.modalContainer}
                okText="Cancel"
                cancelText="Yes, Delete"
                title="Delete Data?"
                description={<p>Are you Sure want to delete <strong>Skillset ID {selectedId}</strong>?</p>}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => navigate(ROUTES.SKILLSET.LIST)}
                closable={false}
                width={280}
                className={style.deleteModal}
                okText="Ok"
                title="Success"
                description="Your data has been deleted"
            />

            <Breadcumbs
                jmlLevel={4}
                menuLevel1={`Master`}
                menuLevel2={`Fleet`}
                menuLevel3={`Skillset`}
                menuLevel4={`Detail Skillset ${detailSkillset.skill_set_id} - ${detailSkillset.skill_set_type}`}
            />

            <div className="flex items-center justify-between gap-[22px]">
                <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => backToSkillsetList()}>
                    <img src={BackIcon} alt="back-icon" />
                    <h1 className='font-sans-bold text-2xl' id='title'>{`${t("SKILLSET_DETAIL:TITLE")} ${detailSkillset.skill_set_id} - ${detailSkillset.skill_set_type}`}</h1>
                </div>

                <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
                    <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detailSkillset.created_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detailSkillset.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{detailSkillset.updated_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detailSkillset.updated_at, true)}</strong></p>
                </div>
            </div>

            <div className="border-[#DDDDDD] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px]">
                <h3 className="font-roboto font-medium mb-[16px] text-lg">{t("SKILLSET_DETAIL:SKILLSET_INFORMATION")}</h3>

                <div className="flex flex-col gap-[16px]">
                    <div className="flex flex-col">
                        <label className="font-normal text-[#818181] text-md">{t("SKILLSET_DETAIL:SKILLSET_TYPE_LABEL")}</label>
                        <p className="text-[#424242] font-roboto text-[20px]">{detailSkillset.skill_set_type}</p>
                    </div>
                    <div className="flex flex-col">
                        <label className="font-normal text-[#818181] text-md">{t("SKILLSET_DETAIL:SKILLSET_LABEL")}</label>
                        <p className="text-[#424242] font-roboto text-[20px]">{detailSkillset.skill_set_name}</p>
                    </div>
                    <div className="flex flex-col">
                        <label className="font-normal text-[#818181] text-md">{t("SKILLSET_DETAIL:DESCRIPTION_LABEL")}</label>
                        <p className="text-[#424242] font-roboto text-[20px]">{detailSkillset.description}</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-row-reverse justify-start gap-[16px]">
                <button className="bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]" onClick={() => toEditSkillSet(detailSkillset)}>
                    {t("SKILLSET_DETAIL:EDIT_BUTTON")}
                </button>
                <button className="border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]" onClick={() => deleteConfirmation(detailSkillset.skill_set_id, detailSkillset.updated_at)}>
                    {t("SKILLSET_DETAIL:DELETE_BUTTON")}
                </button>
            </div>


            <aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
                <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
                    <img src={CloseIcon} alt="" />
                </button>

                <h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
                <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detailSkillset.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detailSkillset.created_at)}</strong></p>


                <div className={style.timelineContainer}>
                    <Timeline>
                        {
                            managementHistoryList.map((item, index) => {
                                if (index === 0) {
                                    return (
                                        <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                                            <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                                                <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                                                <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                                                <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                                            </div>
                                        </Timeline.Item>
                                    )
                                } else {
                                    return (
                                        <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                                            <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                                                <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                                                <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                                                <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                                            </div>
                                        </Timeline.Item>
                                    )
                                }
                            })
                        }
                    </Timeline>
                </div>
            </aside>
        </div>
    )
}
